import React from "react";
import AbbreviatedMillionNumberFormat from "../../../ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";

function UsInfo({
  units_demanded_automobile = 0,
  units_demanded_mobile_phone = 0,
  growth_rate_automobile = 0,
  growth_rate_mobile_phones = 0
}) {
  return (
    <div className="col-xs-12 mb-20">
      <div className="bg-white p-30">
        <h4 className="title-blue">UNITED STATES</h4>
        <hr />
        <div className="row">
          <div className="col-xs-6">
            <p>
              Units Demanded Automobile:
              <AbbreviatedMillionNumberFormat
                prefix=" "
                value={units_demanded_automobile}
              />
            </p>
            <p>Growth Rate: {growth_rate_automobile}%</p>
          </div>
          <div className="col-xs-6">
            <p>
              Units Demanded Mobile Phones:
              <AbbreviatedMillionNumberFormat
                prefix=" "
                value={units_demanded_mobile_phone}
              />
            </p>
            <p>Growth Rate: {growth_rate_mobile_phones}%</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UsInfo;



// WEBPACK FOOTER //
// ./src/components/ceo/analysis/market/us-info.js